var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"},attrs:{"id":"editor"}})
}
var staticRenderFns = []

export { render, staticRenderFns }